export default __webpack_public_path__ + "static/media/gameplay-icon-2.1cbf6f54.gif";